<template>
  <div class="ssvip">
    <header>
      <p class="e-du">恭喜您获得额度</p>
      <div class="jin-e">
        <span>¥</span>
        <span class="wide">{{Number(creditLimit)|currency}}</span>
      </div>
      <div class="ssvip-img">
        <div class="ssvip-img-left">
          <img src="./images/img_jinbi1@2x.png"/>
          <p>现有额度</p>
          <p>{{creditLimit}}</p>
        </div>
        <div class="ssvip-img-center">
        </div>
        <div class="ssvip-img-right">
          <img src="./images/jinbi02@2x.png"/>
          <p>可提升至</p>
          <p>{{increaseLockAmount}}</p>
        </div>
      </div>
      <p class="kai-tong" @click="jumpVip" v-stat="{ id: 10273, args: { status:'li_xiang' } }">开通【SVIP】立享提额，一次到账 ></p>
    </header>
    <div class="btn-red btn" @click="jumpVip">
      <p>激活更多额度 借{{increaseLockAmount}}元  </p>
    </div>
    <div class="btn-white btn" @click="jumpWithdraw" v-stat="{ id: 10273, args: { status:'zhi_jie' } }">
      <p>只借{{creditLimit}}元</p>
    </div>
    <p class="fan-hui" @click="giveUp">返回首页</p>
  </div>
</template>
<script>
import { judgeClientSystem } from '@/assets/utils'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
export default {
  name: 's-svip-result',
  data () {
    return {
      creditLimit: this.$route.query.creditLimit || 0, // 当前的额度
      increaseLockAmount: this.$route.query.increaseLockAmount || 0 // 提升后的额度
    }
  },
  methods: {
    // 跳转vip界面
    jumpVip () {
      this.$report({
        id: 10273,
        args: {
          status: 'more'
        }
      })
      this.$router.push('/vip/index?target=svip&purchaseSVIP=result')
    },
    giveUp () {
      this.$router.push('/')
    },
    jumpWithdraw () {
      if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS') {
        jsBridge('navigateTo', { path: 'withdraw', exitCurrent: false })
      } else {
        this.$router.push({ path: '/withdraw/index' })
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.ssvip{
  width: 748px;
  min-height: 100%;
  background: #FAFAFA;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  text-align: center;
  padding-top:20px;
  header{
    width: 650px;
    margin:0 auto 46px;
    height: 815px;
    background: #FFFFFF;
    box-shadow: 5px 10px 20px 0px #EEEEEE;
    border-radius: 20px;
    padding-top:110px;
    .e-du{
    font-size: 34px;
    color: #333333;
    }
    .jin-e{
      font-size: 48px;
      font-family: DIN-Medium, DIN;
      font-weight: 500;
      color: #333333;
      margin-top:11px;
      .wide{
        font-size: 72px;
        padding-left:9px;
      }
    }
    .ssvip-img{
      margin:84px auto 0;
      width:312px;
      display: flex;
      justify-content: space-between;
      font-size: 26px;
      color: #666666;
      &-left,&-right{
        >img{
          width:122px;
          height:141px;
        }
      }
      &-center{
        margin-top:58px;
        background:url('./images/img_jiantou@2x.png');
        background-size:cover;
        width:41px;
        height:32px;
      }
    }
    .kai-tong{
      width: 480px;
      background: linear-gradient(90deg, #FEF6E4 0%, #FCD5AC 100%);
      font-size: 24px;
      color: #763E12;
      text-align: center;
      line-height: 70px;
      margin:20px auto 0;
      border-radius:15px;
    }
  }
  .fan-hui{
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    margin-top:46px;
    text-align:center;
  }
  .btn{
    width: 650px;
    border-radius: 47px;
    line-height: 94px;
    text-align: center;
    margin:20px auto 0;
    font-size: 30px;
    margin:20px auto 0;
  }
  .btn-white{
    border: 1px solid #FF4633;
    color: #FF4633;
    background:white;
  }
  .btn-red{
    background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
    color: #FFFFFF;
  }
}
</style>